module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(withListResultLayer) { ;
__p += '\n<div class="DescartesUIListResultLayers">\n  ';
  
      var nbLayerWithResult = 0;
      var nbLayerEmptyResult = 0;

      _.forEach(model,function(data, index) {
         if (data.layerDatas.length === 0) {
         nbLayerEmptyResult++;
         } else {
         nbLayerWithResult++;
         }
      });

     var textWithResult = "";
     if (nbLayerWithResult !== 0) {
       if (nbLayerWithResult == 1) {
         textWithResult = nbLayerWithResult + " couche contient des résultats";
       } else {
         textWithResult = nbLayerWithResult + " couches contiennent des résultats";
       }
     }
     var textEmpty = "";
     if (nbLayerEmptyResult !== 0) {
       if (nbLayerEmptyResult == 1) {
         textEmpty = nbLayerEmptyResult + " couche sans résultat";
       } else {
         textEmpty = nbLayerEmptyResult + " couches sans résultat";
       }
     }

  ;
__p += '\n\n  ';
 if(nbLayerWithResult > 0) { ;
__p += '\n    <div class="DescartesUITextGras">\n      ' +
((__t = ( textWithResult)) == null ? '' : __t) +
'\n    </div>\n    ';
 _.forEach(model,function(data, index) {
            var idClass = id + 'tab' + index;
            var headerClass = (index===0 ? 'active':'');
            var headerTitle = data.layerTitle + ' (' + data.layerDatas.length + ')';
            if (data.layerDatas.length !== 0) {
        ;
__p += '\n          <a class="DescartesUIListLink ' +
((__t = (headerClass)) == null ? '' : __t) +
'" href="#' +
((__t = (idClass)) == null ? '' : __t) +
'" tabindex="' +
((__t = (index)) == null ? '' : __t) +
'" data-toggle="tabListResultLayers">\n            ';
 if(withResultLayerExport) { ;
__p += '\n            <span class="' +
((__t = (panelHeaderResultLayerExportClassName)) == null ? '' : __t) +
'" title="' +
((__t = (btResultLayerExportTitle)) == null ? '' : __t) +
'"></span>\n            ';
 } ;
__p += '\n            ';
 if(withCsvExport) { ;
__p += '\n            <span class="' +
((__t = (panelHeaderExportClassName)) == null ? '' : __t) +
' fa fa-save" title="' +
((__t = (btCsvExportTitle)) == null ? '' : __t) +
'"></span>\n            ';
 } ;
__p += '\n            <span class="DescartesUITabbedTitle" title="' +
((__t = (headerTitle)) == null ? '' : __t) +
'">' +
((__t = (headerTitle)) == null ? '' : __t) +
'</span>\n         </a>\n    ';
 }}); ;
__p += '\n  ';
 } ;
__p += '\n  ';
 if(nbLayerEmptyResult > 0) { ;
__p += '\n     <div class="DescartesUITextGras">\n        ' +
((__t = ( textEmpty)) == null ? '' : __t) +
'\n     </div>\n     ';
 _.forEach(model,function(data, index) {
            var idClass = id + 'tab' + index;
            var headerClass = (index===0 ? 'active':'');
            var headerTitle = data.layerTitle + ' (' + data.layerDatas.length + ')';
            if (data.layerDatas.length === 0) {
        ;
__p += '\n          <a class="DescartesUIListLink ' +
((__t = (headerClass)) == null ? '' : __t) +
'" href="#' +
((__t = (idClass)) == null ? '' : __t) +
'" tabindex="' +
((__t = (index)) == null ? '' : __t) +
'" data-toggle="tabListResultLayers">\n            ';
 if(withResultLayerExport) { ;
__p += '\n            <span class="' +
((__t = (panelHeaderResultLayerExportClassName)) == null ? '' : __t) +
'" title="' +
((__t = (btResultLayerExportTitle)) == null ? '' : __t) +
'"></span>\n            ';
 } ;
__p += '\n            ';
 if(withCsvExport) { ;
__p += '\n            <span class="' +
((__t = (panelHeaderExportClassName)) == null ? '' : __t) +
' fa fa-save" title="' +
((__t = (btCsvExportTitle)) == null ? '' : __t) +
'"></span>\n            ';
 } ;
__p += '\n            <span class="DescartesUITabbedTitle" title="' +
((__t = (headerTitle)) == null ? '' : __t) +
'">' +
((__t = (headerTitle)) == null ? '' : __t) +
'</span>\n         </a>\n      ';
 }}); ;
__p += '\n  ';
 } ;
__p += '\n</div>\n';
 } ;
__p += '\n\n<div class="DescartesUIResults" id="' +
((__t = (id)) == null ? '' : __t) +
'"> \n  <ul class="DescartesNavTabs nav nav-tabs" role="tablist">\n        ';
 _.forEach(model,function(data, index) {
            var idClass = id + 'tab' + index;
            var headerClass = (index===0 ? 'active':'');
            var headerTitle = data.layerTitle + ' (' + data.layerDatas.length + ')';
            var headerTitleTroncate = data.layerTitle.slice(0,8) + '... (' + data.layerDatas.length + ')';
        ;
__p += '\n        <li class="nav-item"><a class="nav-link ' +
((__t = (headerClass)) == null ? '' : __t) +
'" href="#' +
((__t = (idClass)) == null ? '' : __t) +
'" data-toggle="tab">\n            ';
 if(withResultLayerExport) { ;
__p += '\n            <span class="' +
((__t = (panelHeaderResultLayerExportClassName)) == null ? '' : __t) +
'" title="' +
((__t = (btResultLayerExportTitle)) == null ? '' : __t) +
'"></span>\n            ';
 } ;
__p += '\n            ';
 if(withCsvExport) { ;
__p += '\n            <span class="' +
((__t = (panelHeaderExportClassName)) == null ? '' : __t) +
' fa fa-save" title="' +
((__t = (btCsvExportTitle)) == null ? '' : __t) +
'"></span>\n            ';
 } ;
__p += '\n            <span class="DescartesUITabbedTitle" title="' +
((__t = (headerTitle)) == null ? '' : __t) +
'">' +
((__t = (headerTitleTroncate)) == null ? '' : __t) +
'</span>\n        </a></li>\n        ';
 }); ;
__p += '\n    </ul>\n    <div class="tab-content ' +
((__t = (panelContentClassName)) == null ? '' : __t) +
'">\n        ';
 _.forEach(model,function(data, index) {
            var idClass = id + 'tab' + index;
            var tableId = 'table_' + id + '_' + index;
            var active = index==0 ? 'active':'';
            var msgError = data.layerMsgError.split(' - ');
        ;
__p += '\n        <div class="tab-pane ' +
((__t = (active)) == null ? '' : __t) +
'" id="' +
((__t = (idClass)) == null ? '' : __t) +
'">\n \n            ';
 if(msgError !== "") { ;
__p += '\n               <div class="DescartesUIResultsMsgError">\n                  ' +
((__t = (msgError[0])) == null ? '' : __t) +
'\n               </div>\n               <div class="DescartesUIResultsMsgErrorTechnique">\n                  ' +
((__t = (msgError[1])) == null ? '' : __t) +
'\n               </div>\n            ';
 } ;
__p += '\n            <div id="' +
((__t = (tableId)) == null ? '' : __t) +
'" ></div>\n        </div>\n        ';
 }); ;
__p += '\n    </div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/TabbedDataGrids.ejs
// module id = 315
// module chunks = 0